import { createFetcher, ROUTES } from '../api'

export const fetchSocialMediaUpdateMatter = createFetcher({
  url: ROUTES.SOCIAL.UPDATE_MATTER,
  withTokens: true,
  method: 'PATCH',
})
